import React, { useEffect, useState } from "react";
import { Row, Col, Modal, Button, Badge } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
import { IoEyeOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import waringSign from "../../assets/images/warnOmc.png";
import pdfIcon from "../../assets/images/pdf-icon.png";
import { AWSUpload } from "../../Upload/awsupload";

const DepartmentalCandidate = ({
  handelApplicationDetailsChange,
  applicationDetails,
  closingDate,
  style,
}) => {
  const [formData, setFormData] = useState({
    departmentalCandidate: applicationDetails?.departmentalCandidate || "",
    departmentalEmployeeId: applicationDetails?.departmentalEmployeeId || "",
    departmentalTotalServicePeriod:
      applicationDetails?.departmentalTotalServicePeriod || "",
    departmentalJoiningDate: applicationDetails?.departmentalJoiningDate || "",
    departmentalSameSubCadre:
      applicationDetails?.departmentalSameSubCadre || "",
    departmentalFiles: applicationDetails?.departmentalFiles || [
      { file: null, name: "", verified: false },
    ], // Array of files
  });
  const [fieldErrors, setFieldErrors] = useState({});
  const [sameSubCaderModal, setSameSubCaderModal] = useState(false);
  const [showIframe, setShowIframe] = useState(null); // To track which file's iframe to show

  useEffect(() => {
    handelApplicationDetailsChange(formData);
  }, [formData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      if (name === "departmentalCandidate" && value === "No") {
        // Reset related fields if "No" is selected

        return {
          departmentalCandidate: value,
          departmentalEmployeeId: "",
          departmentalTotalServicePeriod: "",
          departmentalJoiningDate: "",
          departmentalSameSubCadre: "",
          departmentalFiles: [{ file: null, name: "", verified: false }],
        };
      }

      if (name === "departmentalSameSubCadre" && value === "No") {
        setSameSubCaderModal(true);
        return {
          departmentalCandidate: value,
          departmentalEmployeeId: "",
          departmentalTotalServicePeriod: "",
          departmentalJoiningDate: "",
          departmentalSameSubCadre: value,
          departmentalFiles: [{ file: null, name: "", verified: false }],
        };
      } else {
        return {
          ...prev,
          [name]: value,
        };
      }
    });

    // Update other fields normally
  };

  const advertisementClosingDate = new Date(closingDate);

  const calculateServicePeriod = (joiningDate) => {
    if (!joiningDate) return;

    const startDate = new Date(joiningDate);
    const endDate = new Date(advertisementClosingDate);

    let years = endDate.getFullYear() - startDate.getFullYear();
    let months = endDate.getMonth() - startDate.getMonth();
    let days = endDate.getDate() - startDate.getDate();

    if (days < 0) {
      months -= 1;
      days += new Date(endDate.getFullYear(), endDate.getMonth(), 0).getDate();
    }

    if (months < 0) {
      years -= 1;
      months += 12;
    }

    const totalServicePeriod = `${years} Years, ${months} Months, ${days} Days`;

    setFormData((prevData) => ({
      ...prevData,
      departmentalTotalServicePeriod: totalServicePeriod,
    }));
  };

  const checkErrorFn = (camelCaseKey, immediateValue, index = null) => {
    setFieldErrors((prevErrors) => {
      let errCount = 0;
      const newErrors = { ...prevErrors };

      if (!immediateValue) {
        errCount++;
        const errorMessage = "This field is required.";
        if (index !== null) {
          newErrors[`${camelCaseKey}_${index}`] = {
            errors: [...new Set([errorMessage])],
            touched: true,
          };
        } else {
          newErrors[camelCaseKey] = {
            errors: [...new Set([errorMessage])],
            touched: true,
          };
        }
      } else {
        switch (camelCaseKey) {
          case "departmentalEmployeeId":
            const regexEmployeeId = /^[a-zA-Z0-9]+$/; // Alphanumeric regex
            if (!regexEmployeeId.test(immediateValue)) {
              errCount++;
              newErrors[camelCaseKey] = {
                errors: [...new Set(["Invalid Employee ID."])],
                touched: true,
              };
            }
            break;

          case "departmentalSameSubCadre":
            if (immediateValue === "No") {
              errCount++;
              newErrors[camelCaseKey] = {
                errors: [...new Set(["You are not eligible."])],
                touched: true,
              };
            }
            break;

          case "departmentalJoiningDate":
            const regexDate =
              /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/; // Date in YYYY-MM-DD format
            if (!regexDate.test(immediateValue)) {
              errCount++;
              newErrors[camelCaseKey] = {
                errors: [
                  ...new Set(["Enter a valid date in YYYY-MM-DD format."]),
                ],
                touched: true,
              };
            }
            break;

          case "departmentalCandidate":
            if (!["Yes", "No"].includes(immediateValue)) {
              errCount++;
              newErrors[camelCaseKey] = {
                errors: [...new Set(["Please select Yes or No."])],
                touched: true,
              };
            }
            break;

          case "departmentalFile":
            if (!immediateValue) {
              errCount++;
              if (index !== null) {
                newErrors[`departmentalFile_${index}`] = {
                  errors: [...new Set(["NO file choosen"])],
                  touched: true,
                };
              }
            }
            break;

          case "departmentalFileName":
            if (immediateValue.trim() === "") {
              errCount++;
              if (index !== null) {
                newErrors[`${camelCaseKey}_${index}`] = {
                  errors: [...new Set(["File name cannot be empty."])],
                  touched: true,
                };
              }
            }
            break;

          default:
            break;
        }
      }

      if (errCount < 1) {
        if (index !== null) {
          newErrors[`${camelCaseKey}_${index}`] = {
            errors: [],
            touched: true,
          };
        } else {
          newErrors[camelCaseKey] = {
            errors: [],
            touched: true,
          };
        }
      }

      return newErrors;
    });
  };

  // Handler for adding a new file
  const addFile = () => {
    setFormData((prevData) => ({
      ...prevData,
      departmentalFiles: [
        ...prevData.departmentalFiles,
        { file: null, name: "", verified: false },
      ],
    }));
  };

  // Handler for removing a file
  const removeFile = (index) => {
    const updatedFiles = [...formData.departmentalFiles];
    updatedFiles.splice(index, 1);
    setFormData((prevData) => ({
      ...prevData,
      departmentalFiles: updatedFiles,
    }));
    // Remove any associated errors
    const updatedErrors = { ...fieldErrors };
    delete updatedErrors[`departmentalFileName_${index}`];
    delete updatedErrors[`departmentalFile_${index}`];
    setFieldErrors(updatedErrors);
  };

  // Handler for file input change
  const handleFileChange = async (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const isPDF = file.type === "application/pdf";
      const isUnder2MB = file.size <= 2 * 1024 * 1024;
      if (!isPDF) {
        toast.warn("Invalid file type. Only PDF files are allowed.");
        return;
      }

      const fileUrl = await AWSUpload(file); // Assuming UploadPdf returns a URL
      if (fileUrl) {
        const updatedFiles = [...formData.departmentalFiles];
        updatedFiles[index] = {
          ...updatedFiles[index],
          file: fileUrl,
          verified: false,
        };
        setFormData((prevData) => ({
          ...prevData,
          departmentalFiles: updatedFiles,
        }));
        // Reset verification status
        setFieldErrors((prevErrors) => ({
          ...prevErrors,
          [`departmentalFile_${index}`]: {
            errors: [],
            touched: true,
          },
        }));
      }
    }
  };

  // Handler for name input change
  const handleFileNameChange = (e, index) => {
    const { value } = e.target;
    const updatedFiles = [...formData.departmentalFiles];
    updatedFiles[index].name = value;
    setFormData((prevData) => ({
      ...prevData,
      departmentalFiles: updatedFiles,
    }));
    checkErrorFn("departmentalFileName", value, index);
  };

  // Handler to open the iframe modal for verification
  const handleOpenVerificationModal = (index) => {
    setShowIframe(index);
  };

  // Handler to confirm verification
  const handleConfirmVerification = () => {
    if (showIframe !== null) {
      const updatedFiles = [...formData.departmentalFiles];
      updatedFiles[showIframe].verified = true;
      setFormData((prevData) => ({
        ...prevData,
        departmentalFiles: updatedFiles,
      }));
      setFieldErrors((prevErrors) => ({
        ...prevErrors,
        [`departmentalFile_${showIframe}`]: {
          errors: [],
          touched: true,
        },
      }));
      setShowIframe(null); // Close the modal after verification
      toast.success("File verified successfully!");
    }
  };

  return (
    <>
      <Row>
        <Col xs={12} md={12}>
          <div
            style={{
              fontFamily: "'Roboto', sans-serif",
              color: "brown",
              fontWeight: "bold",
              marginBottom: "16px",
            }}
          >
            <ol style={{ marginTop: "16px" }}>
              <li>
                Note: Candidates who are regular employees of OMC shall only be
                considered as departmental candidates.
              </li>
            </ol>
          </div>
        </Col>
        <Col xs={12} md={4}>
          <div className="mb-1">
            <label className="form-label inputBoxHeadForm" style={style.label}>
              Are you a departmental candidate of OMC?
              <span className="mx-1 text-danger">*</span>
            </label>
            <select
              name="departmentalCandidate"
              value={formData.departmentalCandidate}
              onChange={(e) => {
                handleInputChange(e);
                checkErrorFn("departmentalCandidate", e.target.value);
              }}
              onBlur={() =>
                checkErrorFn(
                  "departmentalCandidate",
                  formData["departmentalCandidate"]
                )
              }
              style={
                fieldErrors?.["departmentalCandidate"]?.errors?.length > 0 &&
                fieldErrors?.["departmentalCandidate"]?.touched
                  ? { ...style.input, ...style.errorBox }
                  : style.input
              }
            >
              <option value="" disabled>
                Select
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            {fieldErrors?.["departmentalCandidate"]?.errors?.length > 0 &&
              fieldErrors?.["departmentalCandidate"]?.touched &&
              fieldErrors?.["departmentalCandidate"]?.errors.map((err, idx) => (
                <span
                  key={idx}
                  className="errorPresent"
                  style={style.errorSpan}
                >
                  {err}
                  <br />
                </span>
              ))}
          </div>
        </Col>

        {formData.departmentalCandidate === "Yes" && (
          <>
            <Col xs={12} md={4}>
              <div className="mb-1">
                <label
                  className="form-label inputBoxHeadForm"
                  htmlFor="departmentalSameSubCadre"
                  style={style.label}
                >
                  Do you belong to the same cadre?{" "}
                  <span className="mx-1 text-danger">*</span>
                </label>
                <select
                  id="departmentalSameSubCadre"
                  name="departmentalSameSubCadre"
                  value={formData.departmentalSameSubCadre}
                  onChange={(e) => {
                    const value = e.target.value;
                    handleInputChange(e);
                    checkErrorFn("departmentalSameSubCadre", e.target.value);
                    if (value === "No") {
                      // Clear all specified fields except `departmentalCandidate`
                      setFormData((prevFormData) => ({
                        ...prevFormData,
                        departmentalEmployeeId: "",
                        departmentalTotalServicePeriod: "",
                        departmentalJoiningDate: "",
                        departmentalSameSubCadre: "",
                        departmentalCandidate: "No",
                        departmentalFiles: [
                          { file: null, name: "", verified: false },
                        ], // Clear uploaded files
                      }));
                    }
                  }}
                  onBlur={() =>
                    checkErrorFn(
                      "departmentalSameSubCadre",
                      formData["departmentalSameSubCadre"]
                    )
                  }
                  style={
                    fieldErrors?.["departmentalSameSubCadre"]?.errors?.length >
                      0 && fieldErrors?.["departmentalSameSubCadre"]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                >
                  <option value="" disabled>
                    Select an option
                  </option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                {fieldErrors?.["departmentalSameSubCadre"]?.errors?.length >
                  0 &&
                  fieldErrors?.["departmentalSameSubCadre"]?.touched &&
                  fieldErrors?.["departmentalSameSubCadre"]?.errors.map(
                    (err, idx) => (
                      <span
                        key={idx}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {err}
                        <br />
                      </span>
                    )
                  )}
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="mb-1">
                <label
                  className="form-label inputBoxHeadForm"
                  htmlFor="departmentalEmployeeId"
                  style={style.label}
                >
                  Employee ID <span className="mx-1 text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  id="departmentalEmployeeId"
                  name="departmentalEmployeeId"
                  value={formData.departmentalEmployeeId}
                  onChange={(e) => {
                    handleInputChange(e);
                    fieldErrors?.["departmentalEmployeeId"]?.touched &&
                      checkErrorFn("departmentalEmployeeId", e.target.value);
                  }}
                  onBlur={() =>
                    checkErrorFn(
                      "departmentalEmployeeId",
                      formData["departmentalEmployeeId"]
                    )
                  }
                  style={
                    fieldErrors?.["departmentalEmployeeId"]?.errors?.length >
                      0 && fieldErrors?.["departmentalEmployeeId"]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                />
                {fieldErrors?.["departmentalEmployeeId"]?.errors?.length > 0 &&
                  fieldErrors?.["departmentalEmployeeId"]?.touched &&
                  fieldErrors?.["departmentalEmployeeId"]?.errors.map(
                    (err, idx) => (
                      <span
                        key={idx}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {err}
                        <br />
                      </span>
                    )
                  )}
              </div>
            </Col>

            <Col xs={12} md={4}>
              <div className="mb-1">
                <label
                  className="form-label inputBoxHeadForm"
                  htmlFor="departmentalJoiningDate"
                  style={style.label}
                >
                  Joining Date <span className="mx-1 text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="date"
                  id="departmentalJoiningDate"
                  name="departmentalJoiningDate"
                  value={formData.departmentalJoiningDate}
                  onChange={(e) => {
                    handleInputChange(e);
                    calculateServicePeriod(e.target.value); // Call the function to calculate service period
                    fieldErrors?.["departmentalJoiningDate"]?.touched &&
                      checkErrorFn("departmentalJoiningDate", e.target.value);
                  }}
                  onBlur={() =>
                    checkErrorFn(
                      "departmentalJoiningDate",
                      formData["departmentalJoiningDate"]
                    )
                  }
                  max={new Date().toISOString().split("T")[0]} // Max is today
                  style={
                    fieldErrors?.["departmentalJoiningDate"]?.errors?.length >
                      0 && fieldErrors?.["departmentalJoiningDate"]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                />
                {fieldErrors?.["departmentalJoiningDate"]?.errors?.length > 0 &&
                  fieldErrors?.["departmentalJoiningDate"]?.touched &&
                  fieldErrors?.["departmentalJoiningDate"]?.errors.map(
                    (err, idx) => (
                      <span
                        key={idx}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {err}
                        <br />
                      </span>
                    )
                  )}
              </div>
            </Col>

            <Col xs={12} md={4}>
              <div className="mb-1">
                <label
                  className="form-label inputBoxHeadForm"
                  htmlFor="departmentalTotalServicePeriod"
                  style={style.label}
                >
                  Total Service Period{" "}
                  <span className="mx-1 text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  id="departmentalTotalServicePeriod"
                  name="departmentalTotalServicePeriod"
                  value={formData.departmentalTotalServicePeriod} // This will be auto-populated
                  disabled
                  style={style.input}
                />
              </div>
            </Col>

            {/* File Upload Section */}
            <Col xs={12} md={12} id="departmentalFileUpload">
              <div className="d-flex">
                <label
                  className="form-label inputBoxHeadForm"
                  style={{ fontWeight: "600", whiteSpace: "nowrap" }}
                >
                  Upload Documents<span className="mx-1 text-danger">*</span>
                </label>
                <div
                  style={{
                    fontSize: "12px",
                    color: "brown",
                    fontWeight: "bold",
                    flex: "1",
                    lineHeight: "1.4",
                    marginTop: "4px",
                  }}
                >
                  ( Please upload any of the documents such as latest payslip /
                  NOC and any other documents in support of departmental
                  candidature. Only PDF files that are under 2 MB in size are
                  accepted. )
                </div>
              </div>

              <div className="mb-3">
                {formData.departmentalFiles.map((fileObj, index) => (
                  <Row key={index} className="align-items-center mb-2">
                    {/* File Upload */}
                    <Col xs={12} md={3}>
                      <div className="d-flex flex-column">
                        <input
                          type="file"
                          accept=".pdf"
                          onChange={(e) => handleFileChange(e, index)}
                          style={{ display: "none" }}
                          onBlur={() =>
                            checkErrorFn(
                              "departmentalFile",
                              fileObj.file,
                              index
                            )
                          }
                          id={`departmentalFile_input_${index}`}
                        />
                        <button
                          type="button"
                          onClick={() =>
                            document
                              .getElementById(`departmentalFile_input_${index}`)
                              .click()
                          }
                          onBlur={() =>
                            checkErrorFn(
                              "departmentalFile",
                              fileObj.file,
                              index
                            )
                          }
                          style={{
                            width: "100%",
                            borderRadius: "10px",
                            height: "37px",
                            fontSize: "12px",
                            cursor: "pointer",
                            border: "none",
                            backgroundColor: "#921d1e",
                            // fieldErrors?.[`departmentalFile_${index}`]?.errors
                            //   ?.length > 0
                            //   ? "#921d1e"
                            //   : "#f0f0f0",
                            color: "#fff",
                            // fieldErrors?.[`departmentalFile_${index}`]?.errors
                            //   ?.length > 0
                            //   ? "#fff"
                            //   : "#333",
                          }}
                        >
                          <span>
                            {fileObj.file ? "Upload File" : "Upload File"}
                          </span>
                        </button>
                        {fieldErrors?.[
                          `departmentalFile_${index}`
                        ]?.errors?.map((err, errIdx) => (
                          <span
                            key={errIdx}
                            className="errorPresent"
                            style={style.errorSpan}
                          >
                            {err}
                          </span>
                        ))}
                      </div>
                    </Col>

                    {/* File Name Input */}
                    <Col xs={12} md={4}>
                      <input
                        type="text"
                        placeholder="Enter File Name"
                        value={fileObj.name}
                        onChange={(e) => handleFileNameChange(e, index)}
                        onBlur={() =>
                          checkErrorFn(
                            "departmentalFileName",
                            fileObj.name,
                            index
                          )
                        }
                        className="form-control"
                        style={
                          fieldErrors?.[`departmentalFileName_${index}`]?.errors
                            ?.length > 0
                            ? { ...style.input, ...style.errorBox }
                            : style.input
                        }
                      />
                      {fieldErrors?.[`departmentalFileName_${index}`]?.errors
                        ?.length > 0 &&
                        fieldErrors?.[
                          `departmentalFileName_${index}`
                        ]?.errors.map((err, errIdx) => (
                          <span
                            key={errIdx}
                            className="errorPresent"
                            style={style.errorSpan}
                          >
                            {err}
                          </span>
                        ))}
                    </Col>

                    {/* Actions: Preview, Verify, Delete */}
                    <Col xs={12} md={5} className="d-flex align-items-center">
                      {fileObj.file && (
                        <>
                          <img
                            src={pdfIcon}
                            alt="PDF Preview"
                            style={{ width: "40px", cursor: "pointer" }}
                            onClick={() => setShowIframe(index)}
                            className="me-2"
                          />

                          {!fileObj.verified ? (
                            <Button
                              //   variant=""
                              size="sm"
                              onClick={() => handleOpenVerificationModal(index)}
                              className="me-2"
                            >
                              Verify
                            </Button>
                          ) : (
                            <Badge
                              bg="success"
                              className="d-flex align-items-center me-2"
                            >
                              <FaCheckCircle size={"18"} className="me-1" />
                              Verified
                            </Badge>
                          )}

                          {/* Preview Icon */}
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => handleOpenVerificationModal(index)}
                            className="me-2"
                          >
                            <IoEyeOutline size={"20"} />
                          </Button>

                          {/* Verify Button or Verified Badge */}

                          {/* Delete Icon */}
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => removeFile(index)}
                          >
                            <MdDeleteOutline size={"20"} />
                          </Button>
                        </>
                      )}
                    </Col>
                  </Row>
                ))}

                {/* Add Another Document Button */}
                <div className="text-end">
                  <Button
                    style={{ backgroundColor: "brown", borderColor: "brown" }}
                    onClick={addFile}
                  >
                    Add File
                  </Button>
                </div>
              </div>
            </Col>
          </>
        )}
      </Row>

      {/* Modal for Warning */}
      {sameSubCaderModal && (
        <Modal
          show={sameSubCaderModal}
          onHide={() => setSameSubCaderModal(false)}
          centered
        >
          <Modal.Header style={{ background: "#921D1E", color: "white" }}>
            <div className="d-flex align-items-center justify-content-center w-100">
              <img src={waringSign} alt="warn" />
            </div>
          </Modal.Header>
          <Modal.Body>
            <h2
              style={{
                color: "#921D1E",
                fontSize: "28px",
                fontFamily: "Roboto",
                textAlign: "center",
              }}
            >
              Warning!
            </h2>
            <p
              style={{
                fontSize: "16px",
                marginTop: "20px",
                fontFamily: "Roboto",
                textAlign: "center",
              }}
            >
              You are not eligible for availing age relaxation as a departmental
              candidate and have to apply as an outside candidate as per your
              own category.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setSameSubCaderModal(false)}
              style={{
                fontSize: "16px",
                fontWeight: "600",
                fontFamily: "Roboto",
                textAlign: "center",
                border: "1px solid #DEBBBB",
                color: "#921D1E",
                background: "#F9F3F4",
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Modal for File Preview and Verification */}
      {showIframe !== null && (
        <Modal
          size="lg"
          show={showIframe !== null}
          onHide={() => setShowIframe(null)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Verify Document</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            {formData.departmentalFiles[showIframe]?.file ? (
              <iframe
                src={formData.departmentalFiles[showIframe].file}
                width="100%"
                style={{ border: "none", height: "50vh" }}
                title="PDF Viewer"
              />
            ) : (
              <p>No file available for preview.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            {!formData.departmentalFiles[showIframe]?.verified && (
              <Button variant="primary" onClick={handleConfirmVerification}>
                Confirm Verification
              </Button>
            )}
            <Button variant="secondary" onClick={() => setShowIframe(null)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default DepartmentalCandidate;
